import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class RegularExpressionLiteralCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.RegularExpressionLiteral;
    }
    visitNode(sb, expr, _options) {
        sb.context.reportUnsupported(expr);
    }
}

//# sourceMappingURL=RegularExpressionLiteralCompiler.js.map
